/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandBulma = createReactComponent("brand-bulma", "IconBrandBulma", [
  ["path", { d: "M5 16l1 -9l5 -5l6.5 6l-3.5 4l5 5l-8 5z", key: "svg-0" }]
]);

export { IconBrandBulma as default };
//# sourceMappingURL=IconBrandBulma.js.map
